<template>
  <a :href="whatsappUrl" class="whatsapp-float" target="_blank" aria-label="WhatsApp">
    <i class="fab fa-whatsapp"></i>
  </a>
</template>

<script setup>
const phoneNumber = '50241498852';
const message = 'Hola visite tu pagina de Vision House';
const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
</script>

<style scoped>
.whatsapp-float {
  position: fixed;
  bottom: 2rem;
  right: 2rem;
  width: 65px;
  height: 65px;
  background: linear-gradient(135deg, #25D366, #128C7E);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 2rem;
  box-shadow: 0 4px 20px rgba(37, 211, 102, 0.4);
  cursor: pointer;
  z-index: 10000;
  text-decoration: none;
  animation: pulseWhatsapp 2.5s infinite;
}
.whatsapp-float:hover {
  transform: scale(1.15) rotate(-5deg);
  box-shadow: 0 8px 30px rgba(37, 211, 102, 0.5);
}
@keyframes pulseWhatsapp {
  0% { box-shadow: 0 0 0 0 rgba(37, 211, 102, 0.7); }
  70% { box-shadow: 0 0 0 25px rgba(37, 211, 102, 0); }
  100% { box-shadow: 0 0 0 0 rgba(37, 211, 102, 0); }
}
</style>